import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {Group} from '../../../graphql/groups.datatypes';
import {gqlGroupsGroup} from './getGroups.api';

interface MyGroupsData {
    groups: void
    myGroups: {
        data: Group[],
        paginatorInfo: PaginatiorInfo,
    }
}

const GET_MY_GROUPS_QUERY = gql`
  query myGroups($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
    myGroups(first: $count, page: $page, where: $where, orderBy: $orderBy){
      data {
        ${gqlGroupsGroup}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getMyGroups = (count: number, page: number, where?: any, orderBy?: any) => useQuery<MyGroupsData>(
    GET_MY_GROUPS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
        },

    }
);

export default getMyGroups;
